module.exports = __webpack_public_path__ + "img/xwzx_tdfc_1920337.5@1x-tuya.b5227c5e.png";